// extracted by mini-css-extract-plugin
export var deleteModal = "_kj-0";